// extracted by mini-css-extract-plugin
var _1 = "ra-image-gallery-clickable-item";
var _2 = "ra-image-gallery";
var _3 = "ra-image-gallery-column";
var _4 = "ra-image-gallery-media-list";
var _5 = "ra-image-gallery-thumbnails-list";
var _6 = "1024px";
export { _1 as "imgGalleryClickableItemCls", _2 as "imgGalleryCls", _3 as "imgGalleryColumnCls", _4 as "imgGalleryMediaListCls", _5 as "imgGalleryThumbnailListCls", _6 as "screenLarge" }
